<template>
  <i v-if="type == 'datastore'" :class="`bx bx-book-open ${customClass}`"></i>
  <i v-else-if="type == 'api'" :class="`bx bx-cloud ${customClass}`"></i>
  <i v-else-if="type == 'weather'" :class="`bx bx-sun ${customClass}`"></i>
  <i v-else-if="type == 'storage_settings'" :class="`bx bxs-data ${customClass}`"></i>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
      default: 'datastore',
    },
    customClass: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.bx-book-open {
  color: #000000;
}
.bx-cloud {
  color: #8d06c1;
}
.bx-sun {
  color: #ffab4c;
}
.bxs-data {
  color: #f40754;
}
</style>
